// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app_3cl75","app__nav":"App_app__nav_3BuA_","app__content":"App_app__content_3TKTA"};